/**
 * Kontrakty adapterów. Ekrany i hooki NIE znają operatorów - znają tylko te dwa kształty.
 * Nowy operator z formularzem karty = nowy plik w adapters/card + wpis w rejestrze.
 * Nowy operator z portfelem = zero zmian (adapter jest per portfel, nie per operator).
 */

export interface CardFormInstance {
  /** bywa asynchroniczny - Przelewy24 pobiera najpierw sesję z naszego backendu */
  mount: (element: HTMLElement) => void | Promise<void>
  /** `multi` gdy klient zgodził się na zapis metody, inaczej `single` */
  tokenize: (kind: payments.CardTokenKind) => Promise<string>
  destroy: () => void
}

export interface CardAdapterOptions {
  lang?: string
  placeholders?: {
    number?: string
    date?: string
    cvv?: string
  }
  /**
   * Adapter melduje, kiedy formularz jest gotowy do wysłania. PayU woła to zaraz po
   * zamontowaniu, Przelewy24 dopiero na evencie `ready` z iframe'a.
   */
  onReady?: (ready: boolean) => void
}

export interface CardAdapter {
  /** SDK jest już załadowane (useScript(cardForm.sdkUrl)) - adapter go nie ładuje */
  create: (cardForm: payments.CardForm, options?: CardAdapterOptions) => CardFormInstance
}

export interface WalletEnvironment {
  sandbox?: boolean
  posId?: string
}

export interface WalletTokenOptions extends WalletEnvironment {
  amount: number
  /** nazwa pokazywana w arkuszu portfela */
  label: string
  /**
   * Apple Pay: arkusz domyka się dopiero po naszej odpowiedzi, więc rozliczenie
   * musi pójść w środku. Zwróć true, gdy backend przyjął wpłatę.
   */
  onAuthorized?: (token: string) => Promise<boolean>
}

export interface WalletAdapter {
  isAvailable: (walletForm: payments.WalletForm, environment?: WalletEnvironment) => Promise<boolean>
  /** zwraca SUROWY JSON tokenu (string) do pola walletForm.tokenField */
  requestToken: (walletForm: payments.WalletForm, options: WalletTokenOptions) => Promise<string>
  /** brandowy przycisk operatora - do wpięcia przy pracach nad wyglądem */
  createButton?: (walletForm: payments.WalletForm, onClick: () => void, environment?: WalletEnvironment) => Promise<HTMLElement>
}

export const walletError = (code: string, message?: string) =>
  Object.assign(new Error(message || code), { code })
